import React from 'react';
import { IBaseAction } from '@models/actions/IBaseAction';
import { DocBaseActionExecutor } from '@organisms/actions/DocBaseActionExecutor';
import { ModalSize } from '@/types/ModalSize';
import { IWIICFreeDateProps } from './IWIICFreeDateProps';
import { WIICFreeDateExecutorModal } from './WIICFreeDateExecutorModal';

export class WIICFreeDateExecutor extends DocBaseActionExecutor {
    private _modalProps?: IWIICFreeDateProps;

    runInternal = (
        objId: string,
        parentId: string | undefined,
        action: IBaseAction,
        rowData?: any,
        completeHandler?: (isSucceed: boolean) => void,
        modalSize?: ModalSize | null,
    ) => {
        this._modalProps = {
            docId: objId ?? '',
            actionKey: action.key ?? '',
            title: action.options?.title ?? '',
            defaultDateField: action.options?.defaultDateField,
            okButtonText: action.options?.okButtonText ?? 'ОК',
            cancelButtonText: action.options?.cancelButtonText ?? 'Отмена',
            modalSize: modalSize ?? action.options?.modalSize ?? 'm',
            completeHandler: completeHandler,
        };
    };

    visualElementInner = () => {
        return this._modalProps ? <WIICFreeDateExecutorModal {...this._modalProps} /> : <div />;
    };
}
